import React from 'react';
import numeral from 'numeral';

import FollowButton from 'components/shared/buttons/follow-button';
import FeedUserType from 'common/feed-user-type';
import ReactDOM from 'react-dom';

import { AvatarUser, Link, Text } from 'components/shared/uniform';

import './athlete-row.scss';

class AthleteRow extends React.Component {
  static propTypes = {
    athlete: React.PropTypes.shape({
      userId: React.PropTypes.string.isRequired,
      fullName: React.PropTypes.string.isRequired,
      lastName: React.PropTypes.string,
      jerseyNumber: React.PropTypes.string,
      positions: React.PropTypes.arrayOf(React.PropTypes.string),
      height: React.PropTypes.string,
      weight: React.PropTypes.string,
      class: React.PropTypes.string,
      highlightCount: React.PropTypes.number,
      highlightViews: React.PropTypes.number,
      followerCount: React.PropTypes.number,
      isDisabled: React.PropTypes.bool,
      currentUserIsFollowing: React.PropTypes.bool,
      profileImageUri: React.PropTypes.string,
      followRequestPending: React.PropTypes.bool,
      followRequestError: React.PropTypes.instanceOf(Error),
    }),
    user: React.PropTypes.shape({
      userId: React.PropTypes.string,
      isPrivilegedUser: React.PropTypes.bool,
    }),
    onFollowUnfollow: React.PropTypes.func.isRequired,
    forcePublicView: React.PropTypes.bool,
    primaryColor: React.PropTypes.string.isRequired,
    secondaryColor: React.PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
  }

  _getAthleteThumbnail() {
    let initials = '';
    if (!this.props.athlete.profileImageUri) {
      const splitName = this.props.athlete.fullName.split(' ');
      splitName.forEach(name => {
        initials += name.substring(0, 1);
      });
    }
    return (
      <AvatarUser
        className="uni-margin--one--right"
        size="medium"
        imageUrl={this.props.athlete.profileImageUri}
        initials={initials}
        primaryColor={this.props.primaryColor ? this.props.primaryColor.replace('#', '') : ''}
        secondaryColor={this.props.secondaryColor ? this.props.secondaryColor.replace('#', '') : ''}
      />
    );
  }

  _getFollowButton() {
    if (this.props.user && this.props.user.userId && !this.props.forcePublicView
      && this.props.user.userId !== this.props.athlete.userId) {
      return (
        <div className="team-athlete-follow">
          <FollowButton
            ref="followButton"
            feedUserTypeId={FeedUserType.User}
            feedUserRelatedId={this.props.athlete.userId}
            isFollowing={this.props.athlete.currentUserIsFollowing}
            requesting={!!this.props.athlete.followRequestPending}
            error={this.props.athlete.followRequestError}
            onClick={this.props.onFollowUnfollow}
            hideText
            allowUnfollow
          />
        </div>
      );
    }

    return (this.props.user && this.props.user.userId && !this.props.forcePublicView)
      ? <div className="team-athlete-follow"></div>
      : null;
  }

  formatViewFollowCount() {
    const athlete = this.props.athlete;
    const views =  numeral(athlete.highlightViews).format();
    const follows =  numeral(athlete.followerCount).format();
    const viewText = athlete.highlightViews === 1 ? 'view' : 'views';
    const followerText = athlete.followerCount === 1 ? 'follower' : 'followers';
    if (!athlete.highlightViews && !athlete.followerCount) {
      return undefined;
    } else if (!athlete.highlightViews) {
      return `${follows} ${followerText}`;
    } else if (!athlete.followerCount) {
      return `${views} ${viewText}`;
    }
    return `${views} ${viewText} / ${follows} ${followerText}`;
  }

  _onClick(e) {
    // Don't link to the athlete when the follow button was clicked. This is
    // a somewhat hacky way to make this work since React changes the behavior
    // of e.preventDefault when using synthetic events. Instead we have to
    // attach this directly to the main anchor tag.
    const followButton = ReactDOM.findDOMNode(this.refs.followButton);
    if (e.target === followButton || followButton.contains(e.target)) {
      e.preventDefault();
    }
  }

  formatAthleteStats() {
    const athlete = this.props.athlete;

    let athleteStats = '';
    if (athlete.positions && athlete.positions.length) {
      athleteStats += athlete.positions[0];
    }
    if (athlete.class) {
      if (athleteStats) {
        athleteStats += ' / ';
      }
      athleteStats += athlete.class;
    }
    if (athlete.height) {
      if (athleteStats) {
        athleteStats += ' / ';
      }
      athleteStats += athlete.height;
    }
    if (athlete.weight) {
      if (athleteStats) {
        athleteStats += ' / ';
      }
      athleteStats += athlete.weight;
    }
    return athleteStats.length ? athleteStats : null;
  }

  getAthleteProfileLink() {
    if (this.props.user.isPrivilegedUser) {
      return '/profile/' + this.props.athlete.userId + '/videos';
    }
    return '/profile/' + this.props.athlete.userId;
  }

  render() {
    const athlete = this.props.athlete;
    const stats = this.formatAthleteStats();
    const viewsAndFollowers = this.formatViewFollowCount();

    return (
      <div className="team-athlete-row">
        <div
          className="team-athlete-row-wrapper"
          onClick={this._onClick}
          href={this.getAthleteProfileLink()}>
          {this._getAthleteThumbnail()}
          <div className="team-athlete-info">
            <span className="team-athlete-full-name">
              <span className="team-athlete-mobile-jersey-number">
                <Text level="small" color="nonessential">
                  {athlete.jerseyNumber ? '#' + athlete.jerseyNumber + ' ' : ''}
                </Text>
              </span>
              <Text>
                <Link type="implied" href={this.getAthleteProfileLink()}>
                  {athlete.fullName}
                </Link>
              </Text>
            </span>
            {!!stats ?
              <div className="team-athlete-data-mobile">
                <Text level="small" color="subtle">
                  {this.formatAthleteStats()}
                </Text>
              </div>
              : null
            }
            <div className="team-athlete-view-follow-count">
              <Text level="small" color="nonessential">
                {viewsAndFollowers}
              </Text>
            </div>
          </div>
          <div className="team-athlete-jersey-number athlete-data-field">
            <span className={!athlete.jerseyNumber ? 'empty' : ''}>
              {athlete.jerseyNumber ? '#' + athlete.jerseyNumber : '-'}
            </span>
          </div>
          <div className="team-athlete-position athlete-data-field">
            <span className={!(athlete.positions && athlete.positions.length) ? 'empty' : ''}>
              {(athlete.positions && athlete.positions.length && athlete.positions[0]) || '-'}
            </span>
          </div>
          <div className="team-athlete-class athlete-data-field">
            <span className={!athlete.class ? 'empty' : ''}>
              {athlete.class || '-'}
            </span>
          </div>
          <div className="team-athlete-height athlete-data-field">
            <span className={!athlete.height ? 'empty' : ''}>
              {athlete.height || '-'}
            </span>
          </div>
          <div className="team-athlete-weight athlete-data-field">
            <span className={!athlete.weight ? 'empty' : ''}>
              {athlete.weight || '-'}
            </span>
          </div>
          {this._getFollowButton()}
        </div>
      </div>
    );
  }
}

export default AthleteRow;
